import React from 'react';
import Svg, { Path } from '@dbk/ui-svg';
import { pure } from '@dbk/ui-react-utils';
import PropTypes from 'prop-types';
import { PALETTE } from '../../../constants';

const SuccessDarkIcon = (props) => {
  const {
    color,
    ...svgProps
  } = props;
  return(
    <Svg {...svgProps} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <Path fill-rule="evenodd" clip-rule="evenodd" d="M0 12C0 5.37273 5.37273 0 12 0C18.6273 0 24 5.37273 24 12C24 18.6273 18.6273 24 12 24C5.37273 24 0 18.6273 0 12ZM5.16295 12.9263L8.70338 16.4557C8.99661 16.748 9.38723 16.9091 9.80168 16.9091C10.2172 16.9091 10.6078 16.748 10.901 16.4557L18.8361 8.55165C19.0008 8.38948 19.0909 8.17258 19.0909 7.94225C19.0899 7.71192 18.9997 7.49501 18.8381 7.33492C18.5117 7.00957 17.9398 7.00957 17.6165 7.33492L9.80168 15.1171L6.38453 11.7107C6.05816 11.3843 5.48518 11.3864 5.16398 11.7086C5.00027 11.8718 4.90909 12.0876 4.90909 12.318C4.90909 12.5494 5.00027 12.7652 5.16295 12.9263Z" fill={color}/>
    </Svg>
  )
}

SuccessDarkIcon.defaultProps = {
  height: 24,
  width: 24,
  color: PALETTE.turquoiseGreen,
};

SuccessDarkIcon.PropTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
}

export default pure(SuccessDarkIcon);